export const API = {
    SEARCH_PRODUCT_FOR_PO: '/api/v1/ProductHeaderItemMaster/SerchProductForPO',
    CREATE_PO_FOR_ITEM_MASTER: '/api/v1/ProductHeaderItemMaster/CreatePurchaseOrderForItemMaster',
    Get_Vendor_Slect_List: '/api/v1/VendorMaster/GetVendorSlectList'
}